import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
/* --- import Components ----*/
import { SectionTitle } from '../Typography';
import { FormSteps } from '../EventForm';
/* --- import Styles ----*/
import { useMediaQueries } from 'src/utils/MediaQueries';
import colors from 'src/style/colors';

const LandingPageBottomFormSection = ({
  dataFromMeetup,
  formattedNextEvent,
  fluid,
  alt,
  formCompleted,
  setFormCompleted,
}) => {
  const mqs = useMediaQueries();

  const textForm = {
    subtitle: ` Posez toutes vos questions, en\u00A0direct, à\u00A0Xavier\u00A0Colombel, fondateur\u00A0du\u00A0Reacteur`,
    fluid: fluid,
    alt: alt,
  };

  return (
    <>
      <SectionTitle isMobileCenter isCenter css={{ marginBottom: 40 }}>
        Inscrivez-vous gratuitement{mqs.tabletLandscapeUp ? <br></br> : ' '}à&nbsp;la&nbsp;prochaine
        {mqs.phoneOnly ? <br></br> : ' '}
        <span css={{ color: colors.yellow }}>réunion&nbsp;d'information</span>
      </SectionTitle>
      {mqs.desktopUp ? (
        <section css={{ display: 'flex', justifyContent: 'center', gap: '50px' }}>
          <div
            css={{
              width: '670px',
            }}
          >
            <FormSteps
              dataFromMeetup={dataFromMeetup}
              selectedEvent={formattedNextEvent}
              formCompleted={formCompleted}
              setFormCompleted={setFormCompleted}
              pageType="landingPage"
              introText={textForm}
              formEndOfPage={true}
              noPhoto
              css={{ width: '100%' }}
            />
          </div>
          <StaticImage
            src="../../data/images/2023_Xavier_entier_rounded.png"
            alt="Le Reacteur - Logo"
            // placeholder="none"
            css={{
              height: '477px',
              width: '320px',
              marginTop: '30px',
              boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.2)',
            }}
          />
        </section>
      ) : (
        <>
          <FormSteps
            dataFromMeetup={dataFromMeetup}
            selectedEvent={formattedNextEvent}
            pageType="landingPage"
            introText={textForm}
            formEndOfPage={true}
          />
        </>
      )}
    </>
  );
};

export default LandingPageBottomFormSection;
